import EntityBase from '@/data/EntityBase';

export default class HourStatsActualState extends EntityBase({
  updating: 0,
}) {}
